import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useCurrentUser } from '@/features/users/users.hooks';
import { useMyWeekLaborQuery } from './my-hours.hooks';
import { getCurrentWeekString, groupLaborByDay } from './my-hours.utils';
import { WeekNavigation } from './components/WeekNavigation';
import { WeekGrid } from './components/WeekGrid';
import { DayCard } from './components/DayCard';

export const MyHoursPanel = ({
  params,
  path,
  ...panelProps
}: RoutedPanelProps) => {
  const { week } = params;
  const currentWeek = week || getCurrentWeekString();
  const currentUser = useCurrentUser();

  const { data: labor, isLoading } = useMyWeekLaborQuery(
    currentUser?.recnum ?? 0,
    currentWeek,
  );

  const days = groupLaborByDay(labor ?? [], currentWeek);
  const weekTotal = days.reduce((sum, d) => sum + d.totalHours, 0);

  return (
    <Panel {...panelProps} title="My Hours">
      <WeekNavigation
        week={currentWeek}
        totalHours={isLoading ? undefined : weekTotal}
      />

      <div className="flex flex-col gap-4">
        {/* Collapsible week grid overview */}
        <WeekGrid days={days} defaultExpanded isLoading={isLoading} />

        {/* Daily breakdown cards */}
        {days.map((day) => (
          <DayCard
            key={day.date.toISOString()}
            day={day}
            isLoading={isLoading}
            linkBase={path}
          />
        ))}
      </div>
    </Panel>
  );
};
